import * as React from "react";
import classnames from "classnames";
import { sortBy } from "lodash";

import {
  RateAdjusters,
  rateAdjusterToTooltip,
  rateAdjusterToLabel,
  operatorHumanizeLoanProgramName,
} from "@eave/shared/types/api";
import LearnMore from "web_modules/shared/LearnMore/index";

import { timestampToLastUpdatedStr } from "web_modules/capital_markets_dashboard/shared/utils";

import RateInput from "../RateInput";

const styles = require("./styles.module.scss");

const renderAdjusterTooltip = key => {
  const tooltipText = rateAdjusterToTooltip(key);

  return tooltipText ? <LearnMore iconTheme="grey" key={key} text={tooltipText} /> : null;
};

const RatesTable = ({
  title,
  lastUpdated,
  currentRates,
  updatedRates,
  editing,
  onEdit,
  sortFunc = () => Infinity,
  suffix = "%",
  precision = 3,
}: {
  title: string;
  lastUpdated: string;
  currentRates: {};
  updatedRates: {};
  editing: boolean;
  onEdit: Function;
  sortFunc: Function;
  suffix?: string;
  precision?: number | { [key: string]: number };
}) => {
  return (
    <div className={styles.container}>
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.updated}>{timestampToLastUpdatedStr(lastUpdated)}</div>
      <table className={styles.table}>
        <thead>
          <tr>
            <th />
            <th>Current</th>
            {editing && <th>New</th>}
          </tr>
        </thead>
        <tbody>
          {sortBy(Object.keys(currentRates), sortFunc).map((k: RateAdjusters) => {
            let finalPrecision: number;
            if (typeof precision === "number") {
              finalPrecision = precision;
            } else {
              finalPrecision = precision[k];
            }

            let display = "-";
            const notFoundRate = "9999.000";
            if (currentRates[k] !== notFoundRate) {
              if (finalPrecision > 0) {
                display = `${Number(currentRates[k]).toFixed(finalPrecision)}${suffix}`;
              } else {
                display = `${String(currentRates[k])}${suffix}`;
              }
            }

            return (
              <tr key={k}>
                <td>
                  {operatorHumanizeLoanProgramName[k] || rateAdjusterToLabel(k)}{" "}
                  {renderAdjusterTooltip(k)}
                </td>
                <td>
                  <div className={styles.current}>{display}</div>
                </td>
                {editing && (
                  <td
                    className={classnames({
                      [styles.edited]: parseFloat(currentRates[k]) !== parseFloat(updatedRates[k]),
                    })}
                  >
                    <RateInput
                      updatedRate={updatedRates[k]}
                      onEdit={rate => onEdit(k, rate)}
                      suffix={suffix}
                    />
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default RatesTable;
